(function () {
  'use strict';

  var bar    = document.getElementById('StickyAtcBar');
  var btn    = document.getElementById('StickyAtcBtn');
  var priceEl = document.getElementById('StickyAtcPrice');
  if (!bar || !btn) return;

  // ── Variant map ──────────────────────────────────────────────────────────
  var variantMap = {};
  var currentVariantId = null;

  try {
    var mapEl = document.getElementById('StickyAtcVariants');
    if (mapEl) {
      JSON.parse(mapEl.textContent).forEach(function (v) {
        variantMap[String(v.id)] = v;
      });
    }
  } catch (e) {}

  btn.dataset.label = btn.textContent.trim();

  function getMainVariantId() {
    var input = document.querySelector('product-form input[name="id"]');
    return input ? input.value : null;
  }

  currentVariantId = getMainVariantId();

  function applyVariant(id) {
    currentVariantId = id;
    var v = variantMap[String(id)];
    if (!v) return;
    if (priceEl) priceEl.textContent = v.price;
    btn.disabled = !v.available;
    btn.textContent = v.available ? btn.dataset.label : 'Sold Out';
    if (v.img) {
      var img = bar.querySelector('.sticky-atc__img');
      if (img && img.tagName === 'IMG') {
        img.src = v.img;
        img.srcset = v.img;  // override srcset so browser uses the new src
      }
    }
  }

  // VariantSelects sets input.value silently (no event), then calls history.replaceState
  // with ?variant=ID. Intercept replaceState as the reliable hook.
  var _replaceState = window.history.replaceState.bind(window.history);
  window.history.replaceState = function (state, title, url) {
    _replaceState(state, title, url);
    if (typeof url === 'string') {
      var match = url.match(/[?&]variant=(\d+)/);
      if (match) applyVariant(match[1]);
    }
  };

  // ── Show / hide ──────────────────────────────────────────────────────────
  var trigger = document.querySelector('product-form');

  function show() { bar.classList.add('sticky-atc--show'); bar.setAttribute('aria-hidden', 'false'); }
  function hide() { bar.classList.remove('sticky-atc--show'); bar.setAttribute('aria-hidden', 'true'); }

  if (trigger && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries[0].isIntersecting ? hide() : show();
    }, { threshold: 0 }).observe(trigger);
  } else {
    window.addEventListener('scroll', function () {
      window.scrollY > 400 ? show() : hide();
    }, { passive: true });
  }

  // ── Add to cart ──────────────────────────────────────────────────────────
  btn.addEventListener('click', function () {
    var variantId = parseInt(getMainVariantId() || currentVariantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.disabled = false;
      btn.textContent = btn.dataset.label;
      var cartNotif = document.querySelector('cart-notification');
      if (cartNotif && data.sections) {
        cartNotif.renderContents(data);
        cartNotif.open();
      } else {
        window.location = '/cart';
      }
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = btn.dataset.label;
      window.location = '/cart';
    });
  });

})();
